import "./index.css";
import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App";
import { HERO_MOCKUP } from "./data/content";
type MetaPixelFunction = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixelFunction;
    _fbq?: MetaPixelFunction;
    requestIdleCallback?: (callback: () => void, options?: {
      timeout: number;
    }) => number;
  }
}
const FONTS_HREF = "https://fonts.googleapis.com/css2?family=Inter:wght@400;600;800&family=Playfair+Display:ital,wght@0,700;1,700&display=swap";

/** Warms up the image that drives the Largest Contentful Paint. */
function preloadHeroImage() {
  const preload = document.createElement("link");
  preload.rel = "preload";
  preload.as = "image";
  preload.href = HERO_MOCKUP;
  preload.setAttribute("fetchpriority", "high");
  document.head.appendChild(preload);
}

/** Loads the web fonts without blocking the first paint (system fallback shows instantly). */
function loadFonts() {
  const preconnect = document.createElement("link");
  preconnect.rel = "preconnect";
  preconnect.href = "https://fonts.gstatic.com";
  preconnect.crossOrigin = "anonymous";
  document.head.appendChild(preconnect);
  const stylesheet = document.createElement("link");
  stylesheet.rel = "stylesheet";
  stylesheet.href = FONTS_HREF;
  stylesheet.media = "print";
  stylesheet.addEventListener("load", () => {
    stylesheet.media = "all";
  });
  document.head.appendChild(stylesheet);
}
function initializeMetaPixel() {
  if (window.fbq) return;
  const fbq: MetaPixelFunction = (...args) => {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
      return;
    }
    fbq.queue?.push(args);
  };
  fbq.queue = [];
  fbq.push = (...args) => fbq.queue?.push(args);
  fbq.loaded = true;
  fbq.version = "2.0";
  window.fbq = fbq;
  window._fbq = fbq;
  const script = document.createElement("script");
  script.async = true;
  script.defer = true;
  script.src = "https://connect.facebook.net/en_US/fbevents.js";
  document.head.appendChild(script);
  fbq("init", "991083460690409");
  fbq("track", "PageView");
}

/** Tracking runs after the page is interactive so it never competes with the first render. */
function scheduleMetaPixel() {
  const start = () => {
    if (typeof window.requestIdleCallback === "function") {
      window.requestIdleCallback(initializeMetaPixel, {
        timeout: 2500
      });
      return;
    }
    window.setTimeout(initializeMetaPixel, 1200);
  };
  if (document.readyState === "complete") {
    start();
    return;
  }
  window.addEventListener("load", start, {
    once: true
  });
}
preloadHeroImage();
loadFonts();
const rootEl = document.getElementById("root");
if (rootEl) {
  ReactDOM.createRoot(rootEl).render(<App data-id="element-312" data-mp="1c35c5bbkztcf" />);
}
scheduleMetaPixel();